import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculators-businessloans-v2.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
var CalculatorsBusinessloansV2 = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorsBusinessloansV2, _super);
    // termChecker: HTMLFormElement[];
    function CalculatorsBusinessloansV2(element) {
        var _this = _super.call(this, element) || this;
        _this.timeout = null;
        _this.formValid = true;
        return _this;
    }
    CalculatorsBusinessloansV2.prototype.init = function () {
        this.inputs = Array.from(this.element.querySelectorAll('input'));
        this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-blc-calculate'));
        this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-blc-reset'));
        this.calculator = this.element.querySelector('form');
        this.removeStepsOnMobile();
        TooltipsService.initTooltips();
    };
    CalculatorsBusinessloansV2.prototype.bindEvents = function () {
        var _this = this;
        this.calculatorSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            // animate to top
            var btnDoIQualify = Array.from(_this.element.querySelectorAll('.js-calculator-do-i-qualify'));
            if ($(window).width() > 768) {
                $('html,body').animate({
                    scrollTop: $('div.calculators').offset().top - 10
                }, 'slow');
                btnDoIQualify.forEach(function (element) {
                    element.classList.remove('button--white');
                    element.classList.remove('button--border-blue');
                    element.classList.add('gradient-orange');
                });
            }
            else if ($(window).width() < 768) {
                $('html,body').animate({
                    scrollTop: $('div.calculator-item__box').offset().top
                }, 'slow');
                setTimeout(function () {
                    btnDoIQualify.forEach(function (element) {
                        element.classList.remove('button--white');
                        element.classList.remove('button--border-blue');
                        element.classList.add('gradient-orange');
                    });
                }, 800);
            }
            if (_this.formValid) {
                var button = event.currentTarget;
                var form = button.closest("form");
                _this.doBLC(form);
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmFormComplete("complete", "");
            }
        }); });
        this.calculatorReset.map(function (item) { return item.addEventListener('click', function (event) {
            _this.resetInputs(event);
            // animate back to top
            if ($(window).width() < 768) {
                $('html,body').animate({
                    scrollTop: $('div.calculators').offset().top - 10
                }, 'slow');
            }
            var btnDoIQualify = Array.from(document.querySelectorAll('.js-calculator-do-i-qualify'));
            btnDoIQualify.forEach(function (element) {
                element.classList.remove('gradient-orange');
                element.classList.add('button--white');
                element.classList.add('button--border-blue');
            });
        }); });
        // INPUTS
        this.inputs.map(function (item) { return item.addEventListener('focusin', function (event) {
            _this.onFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('focusout', function (event) {
            _this.outFocusInput(event);
            _this.validationService.validateCalculator(event, _this.calculatorSubmit);
            var _valid = Array.from(_this.element.querySelectorAll('.calculator-form__error'));
            if (_valid.length > 0) {
                _this.formValid = false;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.add('button--disabled');
                });
            }
            else {
                _this.formValid = true;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.remove('button--disabled');
                });
            }
        }); });
        this.inputs.map(function (item) { return item.addEventListener('keyup', function (event) {
            _this.keyInput(event);
        }); });
        window.addEventListener('resize', this.removeStepsOnMobile);
    };
    CalculatorsBusinessloansV2.prototype.removeStepsOnMobile = function () {
        var btnDoIQualify = Array.from(document.querySelectorAll('.js-calculator-do-i-qualify'));
        var steps = Array.from(document.querySelectorAll('span.calculator-form__button-step'));
        if (window.outerWidth < 768) {
            if (steps) {
                for (var i = 0; i < steps.length; i++) {
                    steps[i].remove();
                }
            }
            btnDoIQualify.forEach(function (element) {
                var newElem = element;
                newElem.style.marginTop = "25px";
            });
        }
    };
    CalculatorsBusinessloansV2.prototype.resetInputs = function (event) {
        event.preventDefault();
        var errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
        errorLabels.map(function (item) {
            var parent = item;
            $(parent).removeClass('calculator-form__error');
            $(parent).find('div.calculator-form__error-label').remove();
        });
        var calculatorForms = Array.from(this.element.querySelectorAll('form'));
        calculatorForms.forEach(function (element) {
            element.reset();
        });
        this.calculator.reset();
        this.formValid = true;
        this.resetValues(this.calculator);
        this.inputs.map(function (item) {
            if (item.getAttribute('type') != 'radio') {
                item.setAttribute('data-value', 0);
                item.setAttribute('placeholder', 0);
            }
        });
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmRestartForm();
    };
    CalculatorsBusinessloansV2.prototype.onFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        var _value = parseFloat(field.value);
        var min = parseFloat(field.getAttribute('min'));
        var max = parseFloat(field.getAttribute('max'));
        if (min && max) {
            if ((_value < min) && (_value > max)) {
                field.value = "";
            }
        }
        else {
            if (_value == 0) {
                field.value = "";
            }
        }
    };
    CalculatorsBusinessloansV2.prototype.outFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        if (!field.classList.contains('js-copy-field')) {
            var value = field.getAttribute('data-value');
            // field.value = value;
            if (field.value == '') {
                field.value = value;
            }
        }
        if (field.value == '') {
            field.value = 0;
        }
    };
    CalculatorsBusinessloansV2.prototype.keyInput = function (event) {
        event.preventDefault();
        this.formValid = true;
        var field = event.target;
        var value = field.value;
        if (!field.classList.contains('js-copy-field')) {
            field.setAttribute('data-value', value);
            field.setAttribute('placeholder', value);
        }
        this.formValid = this.validationService.validateCalculator(event, this.calculatorSubmit);
    };
    //CALCULATOR SERVICES
    CalculatorsBusinessloansV2.prototype.doBLC = function (form) {
        var total = 0;
        var loanamount = form.querySelector('input[name=loan_amount]');
        total = parseFloat(loanamount.value);
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var term = form.querySelector('input[name=term]');
        var output_loan_amount = document.querySelectorAll('span.js-calculator-loan-amount-blc1');
        var output_borrow = document.querySelectorAll('span.js-calculator-estimated-repayment-blc1');
        var output_months = document.querySelectorAll('span.js-calculator-loan-period-blc1');
        var output_date = document.querySelectorAll('span.js-calculator-first-repayment-date-blc1');
        var output_fees = document.querySelectorAll('span.js-calculator-total-interest-blc1');
        var answer = this.PLTMonthlyRepayments(total, interest.value, term.value);
        [].slice.call(output_loan_amount).forEach(function (div) {
            div.innerHTML = answer.loanamount;
        });
        [].slice.call(output_borrow).forEach(function (div) {
            div.innerHTML = answer.estimatedMonthlyRepayment;
        });
        [].slice.call(output_date).forEach(function (div) {
            div.innerHTML = answer.date;
        });
        [].slice.call(output_fees).forEach(function (div) {
            div.innerHTML = answer.totalInterest;
        });
    };
    // BUSINESS LOANS
    CalculatorsBusinessloansV2.prototype.PLTMonthlyRepayments = function (loanamount, loaninterest, loanterm) {
        if (loanamount === void 0) { loanamount = 0; }
        if (loaninterest === void 0) { loaninterest = 0; }
        if (loanterm === void 0) { loanterm = 10.25; }
        var initiationFee = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
        var serviceFee = 60 * 1.15;
        var normalValue = loanamount / loanterm;
        normalValue = this.round(normalValue, 2);
        var monthlyLoanRepayments = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), loanterm, 0) + serviceFee;
        monthlyLoanRepayments = this.round(monthlyLoanRepayments, 2);
        var finalTotalInterestCharge = this.cumipmt2(loaninterest / 1200, loanterm, (loanamount + initiationFee), 1, loanterm, 0);
        var todaysDate = new Date();
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + 1, 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return {
            loanamount: this.formatter(loanamount),
            date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
            iFee: initiationFee,
            sFee: serviceFee,
            totalInterest: this.formatter(finalTotalInterestCharge),
            estimatedMonthlyRepayment: this.formatter(monthlyLoanRepayments)
        };
    };
    CalculatorsBusinessloansV2.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorsBusinessloansV2.prototype.pmt_vaf = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    CalculatorsBusinessloansV2.prototype.cumipmt2 = function (rate, periods, value, start, end, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (value === void 0) { value = 0; }
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = 0; }
        if (type === void 0) { type = 0; }
        var i, interest, payment;
        payment = this.pmt_cumipmt(rate, periods, value, 0, type);
        interest = 0;
        if (start === 1) {
            if (type === 0) {
                interest = -value;
                start++;
            }
        }
        i = start;
        while (i <= end) {
            if (type === 1) {
                interest += this.fv(rate, i - 2, payment, value, 1) - payment;
            }
            else {
                interest += this.fv(rate, i - 1, payment, value, 0);
            }
            i++;
        }
        interest *= rate;
        return -interest;
    };
    CalculatorsBusinessloansV2.prototype.fv = function (rate, periods, payment, value, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (payment === void 0) { payment = 0; }
        if (value === void 0) { value = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        value = value || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = value + payment * periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = value * term + payment * (1 + rate) * (term - 1) / rate;
            }
            else {
                result = value * term + payment * (term - 1) / rate;
            }
        }
        return -result;
    };
    CalculatorsBusinessloansV2.prototype.pmt_cumipmt = function (rate, periods, present, future, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (present === void 0) { present = 0; }
        if (future === void 0) { future = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        future = future || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = (present + future) / periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - (1 / term))) / (1 + rate);
            }
            else {
                result = future * rate / (term - 1) + present * rate / (1 - (1 / term));
            }
        }
        return -result;
    };
    // FORMATTERS
    CalculatorsBusinessloansV2.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    // RESET VALUES	- OUTPUTS
    CalculatorsBusinessloansV2.prototype.resetValues = function (form) {
        switch (form.id) {
            // case 'calculator-personal_loans_test':
            case 'calculator-business_loans_v2':
                var loanamount = form.querySelector('input[name=loan_amount]');
                var output_loan_amount = document.querySelectorAll('span.js-calculator-loan-amount-blc1');
                var output_borrow_blc1 = document.querySelectorAll('span.js-calculator-estimated-repayment-blc1');
                var output_date = document.querySelectorAll('span.js-calculator-first-repayment-date-blc1');
                var output_fees = document.querySelectorAll('span.js-calculator-total-interest-blc1');
                [].slice.call(loanamount).forEach(function (div) {
                    div.innerHTML = '300000';
                });
                [].slice.call(output_loan_amount).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_borrow_blc1).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_date).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_fees).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            default:
                break;
        }
    };
    return CalculatorsBusinessloansV2;
}(Base));
export { CalculatorsBusinessloansV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-businessloans-v2/calculators-businessloans-v2.component.ts
// module id = 803
// module chunks = 0